
import ItemRow from '../components/ItemRow'
import ETAEventCell from '../components/ETAEventCell'
import OverlayDiv from '../components/OverlayDiv'
import moment from 'moment-timezone'
import { isMobile } from 'react-device-detect'
import { canoc } from '../managers/Utils'
import constants from './Constants'

const SectionRow = (props: any) => { 
    const item = props.item;
	const overrideItemKind = props.overrideItemKind;

    const getItemDataProps = (item, kind, aff) => { 
		if (overrideItemKind) { 
			kind = overrideItemKind;
		}
		if (kind === "place") { 
			return { title: item.name, subtitle: item.address + " - " + item.hours, cost: item.cost, image_url: item.image, tags: item.tags, link: item.link }
		} 
		else if (kind === "raw_item") { 
			return { title: item.title, subtitle: item.subtitle_one, cost: null, image_url: item.image, tags: item.tags, link: item.link + `?aff=${aff}`}
		} else if (kind === "collection") { 
			return { title: item.title, subtitle: item.subtitle, cost: null, image_url: item.image, link: item.link }
		} else {
			return { title: item.title, subtitle: moment(item.start_date).format('ddd MMM Do, h:mm a'), cost: item.cost, image_url: item.image_url, tags: item.tags, link: `/event/${item.id}?aff=${aff}`}
		}
	}

    if (item.identifier && (item.identifier.includes("recruit_curator") || item.identifier.includes("rect_overlay"))) { 
			return <OverlayDiv imageUrl={item.items[0].image} width="100%" style={{padding: '32px', height: '300px', marginBottom: '50px', marginRight: '10px', borderRadius: '20px'}}>
				<h1 style={{color: 'white'}}>{item.items[0].title}</h1>
				<p style={{color: 'white'}}>{item.items[0].subtitle_one}</p>
				{item.items[0].subtitle_two && <p style={{color: 'white'}}>{item.items[0].subtitle_two}</p>}

			</OverlayDiv>
		} 

	if (item.item_kind === "collection") { 
		const pickedItem = item.items[0]
		return <a href={"/collections/" + canoc(pickedItem.title, pickedItem.id)} style={{color: constants.EtaButtonColorBright}}><OverlayDiv imageUrl={pickedItem.image_url} width="100%" style={{padding: '32px', paddingTop: '40px', height: '350px', marginBottom: '50px', marginRight: '10px', borderRadius: '25px'}}>
				<p style={{color: constants.EtaButtonColorBright, marginBottom: 0}}><small>Collection</small></p>
				<h1 style={{color: 'white'}}>{pickedItem.title}</h1>
				<p style={{color: 'white'}}>{pickedItem.description}</p>
				{item.items[0].subtitle_two && <p style={{color: 'white'}}>{item.items[0].subtitle_two}</p>}
			</OverlayDiv></a>
	}

	return <ItemRow
		items={item.items}
		title={item.title}
		subtitle={item.description}
		getItemRender = {(rowItem) => <ETAEventCell
			style={{width: isMobile? '300px': 'calc(25% - 20px)', marginRight: '20px'}}
			item={getItemDataProps(rowItem, item.item_kind, props.aff ? props.aff : "front_page")}
			showCost={item.item_kind !== "place"}
			onClick={() => props.onEventClick && props.onEventClick(rowItem)}
			locked={rowItem._locked}
			lockSubtitle={rowItem._lockSubtitle}	
		/> }
		rowItemCount={props.rowItemCount}
		onEventClick={(eventId) => props.onEventClick && props.onEventClick(eventId)}
		onVideoClick={(vid_url, event_id) => props.onVideoClick && props.onVideoClick(vid_url, event_id)}
	/>
}

export default SectionRow;